import { articleApiClient } from '@api/clients';

export const increaseArticleViews = async (id: string): Promise<number> => {
  const response = await articleApiClient.articlesIncreaseViewsIdPut({
    id,
  });

  return response.data;
};
